import React from "react";
import styled from "styled-components";
import "react-image-gallery/styles/css/image-gallery.css";
import ImageGallery from "react-image-gallery";
import image1 from "../../assets/images/aboutus1.jpg";
import image2 from "../../assets/images/aboutus2.jpg";
import image3 from "../../assets/images/aboutus3.jpg";
import image5 from "../../assets/images/djmixing.jpg";
import image6 from "../../assets/images/djstation.jpg";
import image7 from "../../assets/images/headphones.jpg";
import image8 from "../../assets/images/mix.jpg";
import image9 from "../../assets/images/mix2.jpg";

const Gallery = () => {
  const images = [
    {
      original: image1,
      thumbnail: image1,
    },
    {
      original: image2,
      thumbnail: image2,
    },
    {
      original: image3,
      thumbnail: image3,
    },
    {
      original: image5,
      thumbnail: image5,
    },
    {
      original: image6,
      thumbnail: image6,
    },
    {
      original: image7,
      thumbnail: image7,
    },
    {
      original: image8,
      thumbnail: image8,
    },
    {
      original: image9,
      thumbnail: image9,
    },
  ];
  return (
    <>
      <MainWrap id="gallery">
        <ImageGallery
          items={images}
          infinite={true}
          thumbnailPosition="left"
          slideInterval="2500"
          autoPlay={true}
        />
        <iframe
          width="100%"
          height="60"
          src="https://player-widget.mixcloud.com/widget/iframe/?hide_cover=1&mini=1&light=1&feed=%2Fdjbezi%2Fmix-series-vol-11%2F"
          frameborder="0"
        ></iframe>
        <iframe
          width="100%"
          height="60"
          src="https://player-widget.mixcloud.com/widget/iframe/?hide_cover=1&mini=1&light=1&feed=%2Fdjbezi%2Fdjbezi-4tm-exclusive-house-sessh-vol-07%2F"
          frameborder="0"
        ></iframe>
        <iframe
          width="100%"
          height="60"
          src="https://player-widget.mixcloud.com/widget/iframe/?hide_cover=1&mini=1&light=1&feed=%2Fdjbezi%2Fdjbezi-4tm-exclusive-progressive-house-sessh-1%2F"
          frameborder="0"
        ></iframe>
      </MainWrap>
    </>
  );
};

export default Gallery;

const MainWrap = styled.div`
  padding: 50px;

  iframe {
    padding: 20px 0;
  }

  @media (max-width: 767px) {
    padding: 0;
    width: 100vw;
  }
`;
